define([
	"dojo/_base/declare",
	"csi/action/EditController"
], function(declare,EditController) {

	return declare(EditController, {
		origUrlNode: null,
		qrGroup: null,

		constructor: function() {
			// Reference csi/action/GroupController
        	this.qrGroup = this.widget.getQueryResultByDomNode(this.refNode || this.m_element);
    		this.origUrlNode = this.m_urlNode;
    		this.m_urlNode = this.qrGroup.groupValue;
		},

		postProcessSuccess: function() {
			var newName = this.m_formData.getFieldValue("Node Name");
			var qr = this.qrGroup;
			qr.parentResult.store.rename(qr.getNode(), newName);
			this.widget.postActionRedrawNode(this);
		}
	});
});
